import { AutoTask } from '../../../../shared/types/autoTask.ts';


export function getTimeRemaining(task: AutoTask): number {
    const timeDiff = +task.targetTime - +new Date();
    if (task.isTaskUp === false) {
        return Math.max(timeDiff, 1);// Avoid negative time, if task is not up
    } else {
        return timeDiff;
    }
}
